"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceDetailComponent = void 0;
var ClubInvoiceDetail_1 = require("./ClubInvoiceDetail");
Object.defineProperty(exports, "ClubInvoiceDetailComponent", { enumerable: true, get: function () { return ClubInvoiceDetail_1.ClubInvoiceDetailComponent; } });
